import { atom } from 'jotai';

import { getMenuMap } from '@/config';

import { menuAtom } from './common';

interface PayloadParams {
  selectKey: string; // 选中的侧边栏key
  isSubRoute: boolean; // 是否为二级栏，是：true，不是：false(表示在三级栏)
}

export const headTitleAtom = atom(''); // 页面标题

const getHeadTitle = (menuList: any, key: any) => {
  const menuItem = menuList.find((item: any) =>
    item.menu_auth.some((auth: any) => auth.submenu_name === key.selectKey)
  );

  if (!menuItem) return '';

  const submenuItem = menuItem.menu_auth.find((auth: any) => auth.submenu_name === key.selectKey);

  if (key.isSubRoute) {
    return submenuItem.submenu_i18n; // 二级栏面包屑
  }
  const menuMap = getMenuMap();

  const childItem = menuMap[key.selectKey].children.find((child: any) =>
    window.location.hash.includes(child.submenu_name)
  );

  return childItem?.submenu_i18n; // 三级栏面包屑
};

export const setHeadTitleAtom = atom(null, (get, set, payload: PayloadParams) => {
  const menuList = get(menuAtom); // 侧边栏数据

  set(headTitleAtom, getHeadTitle(menuList, payload)); // payload: 入参
});
